import { Helmet } from 'react-helmet-async';
import Hero from '../components/Hero';
import FamilySection from '../components/FamilySection';
import TipsSection from '../components/TipsSection';
import ServicesSection from '../components/ServicesSection';
import TestimonialsSection from '../components/TestimonialsSection';
import SocialProof from '../components/SocialProof';
import ProcessSection from '../components/ProcessSection';
import VideoSection from '../components/VideoSection';
import LatestNewsSection from '../components/LatestNewsSection';
import ContactSection from '../components/ContactSection';

export default function Home() {
  return (
    <>
      <Helmet>
        <title>Online Tryghed | Tryg hjælp til ældre på nettet</title>
        <meta name="description" content="Vi hjælper ældre og sårbare borgere med at blive trygge på nettet. Professionel hjælp mod online svindel, MitID og tekniske udfordringer." />
      </Helmet>

      <main>
        <Hero />
        <TipsSection />
        <FamilySection />
        <ServicesSection />
        <TestimonialsSection />
        <SocialProof />
        <ProcessSection />
        <VideoSection />
        <LatestNewsSection />
        <ContactSection />
      </main>
    </>
  );
}
